import src from "IMAGE";
export default { src, width: 97, height: 80, blurWidth: 0, blurHeight: 0};
